import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * "What's in your box" is rendered per size - Split King gets two fitted sheets, Single and
 * King Single one pillowcase, and the heading names the size - so it has to follow the size
 * picker.
 *
 * Nothing morphs it for free. variant-picker.js only passes a morphElementSelector for a
 * combined-listing product switch; an ordinary size change morphs the picker alone and
 * leaves every other component to update itself from the freshly fetched section in
 * event.detail.data.html. That is why the price moved on a size change and this box did not.
 * Same shape as assets/product-inventory.js.
 */
class PdpWhatsInBox extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateBox);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateBox);
  }

  /**
   * Replaces the box contents with the ones rendered for the newly selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateBox = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBox = event.detail.data.html.querySelector('pdp-whats-in-box');

    if (!newBox) return;

    morph(this, newBox, { childrenOnly: true });
  };
}

if (!customElements.get('pdp-whats-in-box')) {
  customElements.define('pdp-whats-in-box', PdpWhatsInBox);
}
